module.exports = {
  currencies: require('./currencies.json'),
};
